import Main from './index.vue'
import Vue from 'vue'
let CountrySelectionConstructor = Vue.extend(Main)

let instance

const CountrySelection = function (options) {
  if (instance) { return instance }
  options = options || {}
  options.onClose = function () {
    CountrySelection.close()
  }
  instance = new CountrySelectionConstructor({
    data: options
  })
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.visible = true
  return instance
}

CountrySelection.close = function () {
  instance = null
}

export default CountrySelection
